import React, { useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { 
  FaRocket, FaChartLine, FaUsers, 
  FaClipboardCheck, FaCode, FaCloud, 
  FaShieldAlt, FaBolt, FaCog,
  FaDatabase, FaMobile, FaGlobe, FaLightbulb,
  FaHeadset, FaClock, FaTools, FaMagic, FaChartBar
} from 'react-icons/fa';

import { ArrowForward } from '@mui/icons-material';
import HeroBg from '../images/homepage/herobanner.jpg';
import InrHeroBg from '../images/homepage/inrhmpage.png';
import Inrreviewimg from '../images/homepage/review.png';
import logo1 from '../images/homepage/Vector1.png';
import logo2 from '../images/homepage/Vector2.png';
import logo3 from '../images/homepage/Vector3.png';
import logo4 from '../images/homepage/Vector4.png';
import logo5 from '../images/homepage/Vector5.png';
import logo6 from '../images/homepage/Vector6.png';
import ServiceShowcase from './ServiceShowcase.tsx';



/*new css*/
const NewHero = styled.div`
  background: linear-gradient(135deg, #a855f7 0%, #c084fc 25%, #d8b4fe 50%, #e879f9 75%, #f0abfc 100%);
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8rem 0 0rem 0;
  margin: 0 0 4rem 0;
  position: relative;

  @keyframes gradientShift {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @media screen and (max-width: 700px) {
    padding: 5rem 1rem 0 1rem;
  }

    h1, p{
    text-align: center;
    padding: 10px 0;
    color: #fff !important;
    position: relative;
    z-index: 2;
    }

    .button-container {
      display: flex;
      justify-content: center;
      margin: 0 auto;
      padding: 20px 0;
      width: 100%;
      position: relative;
      z-index: 2;
    }

    a{
      display: inline-block;

      svg{
        margin-left: 8px;
        vertical-align: middle;
        background: #fff;
        color: #4F46E5 !important;
        
        border-radius: 50px;

        path {
          fill: blue;
        }
      }

      button{
       border-radius: 50px;
       display: flex;
       align-items: center;
       justify-content: center;
       padding: 12px 24px;
       margin: 0 auto;
      }
    }
    
    h1{
      font-size: 44px;
      line-height: 54px;

      @media screen and (max-width: 700px) {
      font-size: 30px;
      line-height: 38px;
      }

    }
    
    p{
    font-size: 16px;
    line-height: 26px;

    @media screen and (max-width: 700px) {
      font-size: 14px;
      line-height: 23px;
      }
    }

    img{
      width: 20%;
      text-align: center;
      margin: 0 auto;
      position: relative;
      z-index: 2;

      @media screen and (max-width: 700px) {
       width: 70% !important;
      }
    }
`;

const GridOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
    background-size: 50px 50px;
    opacity: 0.3;
  }

  @media screen and (max-width: 700px) {
    &::before {
      background-size: 30px 30px;
    }
  }
`;

const Imagecontainer = styled.div`
  width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: anchor-center;
    position: relative;
    z-index: 2;

    img {
    width: 70%;

  @media screen and (max-width: 700px) {
       width: 100% !important;
      }
    }
`;

const CarouselWrapper = styled.div`
  overflow: hidden;
  width: 100%;

  
`;
const LogoCarousel = styled.div`
  padding: 4rem 0rem;
  overflow: hidden;

  h2 {
    text-align: center;
    font-size: 40px;
    margin-bottom: 2rem;
    line-height: 48px;
    font-family: font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif !important;
    color: #000;
    font-weight: 600;

    @media (max-width: 768px) {
      padding: 10px;
      font-size: 24px;
      line-height: 30px;
    }
  }
  span{
    color: #4F46E5;
  }
`;



const CarouselTrack = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: fit-content;
  animation: scroll 25s linear infinite;
  gap: 50px;

  img {
    height: 50px;
    margin-right: 4rem; 
    opacity: 0.8;
    transition: all 0.3s ease;

    &:hover {
      filter: none;
      opacity: 1;
    }
  }

  @keyframes scroll {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;
const Hero = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Helper functions first
  const getRandomFloat = (min, max) => {
    return Math.random() * (max - min) + min;
  };

  const getRandomPosition = (index, total) => {
    const sectionWidth = 100 / 5; // 5 columns
    const sectionHeight = 100 / 4; // 4 rows

    const col = index % 5;
    const row = Math.floor(index / 5);

    const randomX = getRandomFloat(-sectionWidth/2, sectionWidth/2);
    const randomY = getRandomFloat(-sectionHeight/2, sectionHeight/2);

    const baseX = (col * sectionWidth) + (sectionWidth/2);
    const baseY = (row * sectionHeight) + (sectionHeight/2);

    const x = Math.max(10, Math.min(90, baseX + randomX));
    const y = Math.max(10, Math.min(90, baseY + randomY));

    return {
      left: `${x}%`,
      top: `${y}%`
    };
  };

  // Then the feature badges array
  const featureBadges = [
    { 
      icon: FaRocket,
      text: "Lightning Fast",
      delay: 0.2
    },
    { 
      icon: FaShieldAlt,
      text: "Enterprise Security",
      delay: 0.4
    },
    { 
      icon: FaChartLine,
      text: "Real-time Analytics",
      delay: 0.6
    },
    { 
      icon: FaUsers,
      text: "Team Collaboration",
      delay: 0.8
    },
    { 
      icon: FaBolt,
      text: "Automated Workflows",
      delay: 1.0
    },
    { 
      icon: FaCog,
      text: "Custom Integration",
      delay: 1.2
    },
    { 
      icon: FaDatabase,
      text: "Cloud Storage",
      delay: 1.4
    },
    { 
      icon: FaMobile,
      text: "Mobile Ready",
      delay: 1.6
    },
    { 
      icon: FaGlobe,
      text: "Global Access",
      delay: 1.8
    },
    { 
      icon: FaLightbulb,
      text: "Smart Insights",
      delay: 2.0
    },
    { 
      icon: FaHeadset,
      text: "24/7 Support",
      delay: 2.2
    },
    { 
      icon: FaClock,
      text: "Time Tracking",
      delay: 2.4
    },
    { 
      icon: FaTools,
      text: "Advanced Tools",
      delay: 2.6
    },
    { 
      icon: FaMagic,
      text: "Auto-Magic",
      delay: 2.8
    },
    { 
      icon: FaChartBar,
      text: "Performance Metrics",
      delay: 3.0
    }
  ].map((badge, index, array) => ({
    ...badge,
    position: getRandomPosition(index, array.length)
  }));

  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], [0, 300]);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

  const isMobile = window.innerWidth <= 768;

  return (
    <>
    <NewHero>
      <GridOverlay />
      <motion.h1
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 0.8, 
          ease: "easeOut",
          delay: 0.2 
        }}
      >
        Manage Your Service Operations. <br></br>Anywhere. At Anytime.
      </motion.h1>
      
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 0.8, 
          ease: "easeOut",
          delay: 0.4 
        }}
      >
        Whether you're in the field, at the office, or on the go — ServTrackr gives you full visibility and<br></br> control over your jobs, teams, and customers in real time.
      </motion.p>
      
      <motion.div
        className="button-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 0.8, 
          ease: "easeOut",
          delay: 0.6 
        }}
      >
        <Link to="/free-trial" style={{ textDecoration: 'none' }}>
          <motion.button
            whileHover={{ 
              scale: 1.05,
              boxShadow: "0 10px 25px rgba(255, 255, 255, 0.2)"
            }}
            whileTap={{ scale: 0.98 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
          >
            Start Free Trial 
            <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle', fill: '#fff' }} />
          </motion.button>
        </Link>
      </motion.div>
      
      <motion.img 
        src={Inrreviewimg}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ 
          duration: 0.8, 
          ease: "easeOut",
          delay: 0.8 
        }}
        whileHover={{ scale: 1.02 }}
      />
      
      <Imagecontainer>
        <motion.img 
          src={InrHeroBg}
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 1.2, 
            ease: "easeOut",
            delay: 1.0 
          }}
          whileHover={{ 
            scale: 1.02,
            transition: { duration: 0.3 }
          }}
        />
      </Imagecontainer>
    </NewHero>

    {/*<LogoCarousel>
        <CarouselWrapper>
        <CarouselTrack>
         
           {[logo1, logo2, logo3, logo4, logo5, logo6, logo1, logo2, logo3, logo4, logo5, logo6].map((logo, i) => (
            <img src={logo} alt={`Client ${i}`} key={i} />
            ))}
            {[logo1, logo2, logo3, logo4, logo5, logo6, logo1, logo2, logo3, logo4, logo5, logo6].map((logo, i) => (
            <img src={logo} alt={`Client ${i + 6}`} key={i + 6} />
            ))}
            </CarouselTrack>
            </CarouselWrapper>
          </LogoCarousel> */}

      {/* <HeroSection>
        <ClipPathContainer
          initial={{ y: isMobile ? "-30vh" : "-100vh" }}
          animate={{ y: 0 }}
          transition={{ 
            duration: 0.6,
            ease: [0.165, 0.84, 0.44, 1],
            delay: 0.1
          }}
          style={{ 
            marginTop: isMobile ? "-80px" : "-710px",
          }}
        />
        <HeroGraphic 
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.6 }}
          transition={{ duration: 0.8 }}
        />
        <Container>
          <Content>
            <Title
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.3,
                ease: "easeOut"
              }}
            >
              Manage Your Service Operations
              <br />
              Anywhere
              <br />
              At Anytime
            </Title>
            <Description
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.4,
                ease: "easeOut"
              }}
            >
             Thousands of businesses trust ServTrackr to manage their service operations.
            </Description>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.5,
                ease: "easeOut"
              }}
            >
              <CTAButton to="/free-trial">
                Start now →
              </CTAButton>
            </motion.div>
          </Content>
          <DevicesContainer>
            <MacbookContainer>
              <MacbookFrame>
                <MacbookScreen>
                  <DesktopScreen
                    src="/image.webp"
                    alt="ServTrackr desktop interface"
                  />
                </MacbookScreen>
              </MacbookFrame>
            </MacbookContainer>
            <VideoContainer>
              <IPhoneFrame>
                <DynamicIsland />
                <PowerButton />
                <VolumeButton top="120px" height="50px" />
                <VolumeButton top="180px" height="50px" />
                <VolumeButton top="240px" height="80px" />
                <PhoneScreen
                  src="/iPhoneScreen.webp"
                  alt="ServTrackr mobile app interface"
                />
              </IPhoneFrame>
            </VideoContainer>
          </DevicesContainer>
        </Container>
      </HeroSection> */}
      
      {/* New Service Showcase Component */}

    </>
  );
};

export default Hero;
